module.exports = __webpack_public_path__ + "static/media/error.35bfb91d.svg";